import React, { memo } from 'react'
import DefaultLayout from '../default'
import styled from 'styled-components'

const Child = styled.div`
  background-color: ${props => props.theme.colorTable.backLight};
`

const ChildAccordion = ({
                          id,
                          name,
                          title,
                          isShow,
                          link,
                          context,
                          topRecordId,
                          inLinkedObj,
                          change,
                        }) => {
  if (isShow) {
    return (<Child className={'px-2 pt-2 mt-2 rounded animate__animated animate__fadeIn'}>
      <DefaultLayout context={context}
                     topRecordId={topRecordId}
                     inLinkedObj={inLinkedObj || Boolean(link)}
                     change={change}/>
    </Child>)
  }
  return null
}

export default memo(ChildAccordion)
